import React, { useEffect, useState } from 'react';
import { Clock3Icon } from 'lucide-react';
const INITIAL_SECONDS = 17 * 60 + 33;
function formatTime(seconds: number) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor(seconds % 3600 / 60);
  const remainingSeconds = seconds % 60;
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
}
export function CountdownTimer() {
  const [seconds, setSeconds] = useState(INITIAL_SECONDS);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setSeconds(current => current <= 1 ? INITIAL_SECONDS : current - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  return <div className="mt-4 rounded-xl border border-cyan-300/25 bg-[#071927] px-4 py-3 text-center" aria-live="polite" data-id="element-4" data-mp="15exudczxllaj">
      <p className="flex items-center justify-center gap-2 text-[10px] font-bold uppercase tracking-[0.16em] text-cyan-200" data-id="element-5" data-mp="34oe72ptho471">
        <Clock3Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-6" data-mp="1c05h7s22ybpw" />
        La oferta actual se renueva en
      </p>
      <strong className="mt-1 block font-display text-3xl font-bold tracking-[0.14em] text-white sm:text-4xl" data-id="element-7" data-mp="1h01kfp2ydz4e">
        {formatTime(seconds)}
      </strong>
      <p className="mt-1 text-[10px] uppercase tracking-wider text-slate-400" data-id="element-8" data-mp="124vef23uy0b2">
        Acceso inmediato · Precio promocional
      </p>
    </div>;
}